import { render, staticRenderFns } from "./NsProductDetailInfo.vue?vue&type=template&id=202b4a89&scoped=true&"
import script from "./NsProductDetailInfo.vue?vue&type=script&lang=js&"
export * from "./NsProductDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./NsProductDetailInfo.vue?vue&type=style&index=0&id=202b4a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b4a89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202b4a89')) {
      api.createRecord('202b4a89', component.options)
    } else {
      api.reload('202b4a89', component.options)
    }
    module.hot.accept("./NsProductDetailInfo.vue?vue&type=template&id=202b4a89&scoped=true&", function () {
      api.rerender('202b4a89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductDetailInfo.vue"
export default component.exports